"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationTree = void 0;
const react_1 = __importStar(require("react"));
const NavigationItem_1 = __importDefault(require("./NavigationItem"));
const react_bootstrap_1 = require("react-bootstrap");
const spa_core_1 = require("@episerver/spa-core");
const NavigationTree = (props) => {
    var _a, _b;
    const [open, setOpen] = (0, react_1.useState)('n/a');
    const navItems = [];
    const collapse = (item, active) => {
        if (open === 'n/a' && active)
            setOpen('');
        else
            item === open ? setOpen('') : setOpen(item);
    };
    const backToMenuKeyHandler = (e) => {
        if (e.code === 'Space' || e.code === 'Escape') {
            e.preventDefault();
            props.backToMenu();
        }
    };
    const backToMenu = react_1.default.createElement("li", { className: 'nav-item ps-2 d-none d-md-flex align-items-center justify-content-between back-to-menu' },
        react_1.default.createElement("a", { tabIndex: 0, role: 'button', className: 'py-3 px-2 d-flex align-items-center position-relative', onKeyDown: backToMenuKeyHandler, onClick: () => props.backToMenu() },
            react_1.default.createElement("span", { className: 'icon-arrow-left-tail me-3', "aria-hidden": true }),
            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: 'backToMenu' })));
    const sectionHeading = (props === null || props === void 0 ? void 0 : props.sectionHeading) ? react_1.default.createElement("div", { className: 'col-12 logo-content' },
        react_1.default.createElement("div", { className: 'nav-item mx-md-2 d-flex section-heading font-nav-item h-100 align-items-center align-items-md-end' },
            react_1.default.createElement("div", { tabIndex: -1, className: 'no-outline py-md-3 px-md-2' }, props.sectionHeading))) : react_1.default.createElement(react_1.default.Fragment, null);
    const activeCollapse = (index, active) => {
        if (open === 'n/a' && active)
            return true;
        return open === index.toString();
    };
    if (!props.mobile || props.maxLevelsInMobile > props.navigationLevelAsNum) {
        (_a = props.navigationTree) === null || _a === void 0 ? void 0 : _a.forEach((item, index) => {
            navItems.push(react_1.default.createElement(NavigationItem_1.default, { labels: props.labels, key: item.guid + 'first' + index.toString(), item: item, closeNav: props.closeNav, openLevel: props.openLevel, currentLevel: props.navigationLevel, currentUrl: props.currentUrl, needle: props.needle, removeLastLevel: props.removeLastLevel }));
        });
    }
    else if (props.maxLevelsInMobile === props.navigationLevelAsNum) {
        (_b = props.navigationTree) === null || _b === void 0 ? void 0 : _b.forEach((item, index) => {
            const subItems = [];
            let activeIndex;
            const currentItem = index;
            item.subItems.forEach((subitem, index) => {
                if ((subitem === null || subitem === void 0 ? void 0 : subitem.linkUrl) === props.currentUrl)
                    activeIndex = currentItem;
                subItems.push(react_1.default.createElement(NavigationItem_1.default, { labels: props.labels, key: subitem.guid + 'subitem' + index.toString(), item: subitem, lastItem: true, closeNav: props.closeNav, openLevel: props.openLevel, currentLevel: props.navigationLevel, currentUrl: props.currentUrl, needle: props.needle, removeLastLevel: props.removeLastLevel }));
            });
            navItems.push(react_1.default.createElement(react_1.default.Fragment, { key: item.guid + index.toString() },
                react_1.default.createElement(NavigationItem_1.default, { labels: props.labels, item: item, lastItem: true, closeNav: props.closeNav, openLevel: props.openLevel, currentLevel: props.navigationLevel, collapseToggle: () => collapse(index.toString(), index === activeIndex), ariaControls: index.toString(), ariaExpanded: open === index.toString(), currentUrl: props.currentUrl, needle: props.needle, removeLastLevel: props.removeLastLevel }),
                react_1.default.createElement("div", { className: 'sub-items ps-10' },
                    react_1.default.createElement(react_bootstrap_1.Collapse, { onEntered: () => props.adjustHeight(), onExited: () => props.adjustHeight(), in: activeCollapse(index, index === activeIndex), dimension: "height", className: 'py-3', children: react_1.default.createElement("div", { id: index.toString() }, subItems) }))));
        });
    }
    return react_1.default.createElement("div", { className: `row g-0 w-100 m-0 ${props.navigationLevel ? 'sub-tree' : ''}` },
        react_1.default.createElement("ul", { className: 'col-12' },
            props.showBackToMenu ? backToMenu
                : react_1.default.createElement("li", { "aria-hidden": true, className: 'nav-item d-none d-md-flex align-items-center justify-content-between' },
                    react_1.default.createElement("span", { className: 'py-3 font-nav-item px-2 d-block position-relative' }, '\u00A0')),
            sectionHeading,
            navItems));
};
exports.NavigationTree = NavigationTree;
exports.default = exports.NavigationTree;
